import React, { Component } from 'react';
import Head from '../../../../components/Head/Head';
import Auxiliary from '../../../../hoc/Auxiliary/Auxiliary';
import { withTranslation } from 'react-i18next';
import OutsourcingCostBanner from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingCost/OutsourcingCostBanner/OutsourcingCostBanner';
import OutsourcingCost2 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingCost/OutsourcingCost2/OutsourcingCost2';
import OutsourcingCost3 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingCost/OutsourcingCost3/OutsourcingCost3';
import OutsourcingCost4 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingCost/OutsourcingCost4/OutsourcingCost4';
import OutsourcingCost5 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingCost/OutsourcingCost5/OutsourcingCost5';
import OutsourcingCost6 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingCost/OutsourcingCost6/OutsourcingCost6';

class OutsourcingCost extends Component {
    render() {
        return (
            <Auxiliary>
                <Head id="outsourcing-cost" />
                <OutsourcingCostBanner {...this.props} />
                <OutsourcingCost2 {...this.props} />
                <OutsourcingCost3 {...this.props} />
                <OutsourcingCost4 {...this.props} />
                <OutsourcingCost5 {...this.props} />
                <OutsourcingCost6 {...this.props} />
                <div className='custom-end-outsourcing-cost'></div>
            </Auxiliary>
        );
    }
}

export default withTranslation()(OutsourcingCost);
